import React from 'react'
import styled from 'styled-components'
import { asUnified, ut } from '@devnw/theme'
import { ServiceExplorer } from '../../../gen/client/react-ui'
// The generated explorer ships its own (dependency-free) stylesheet — the
// consumer must import it or the explorer renders with no layout. Webpack
// bundles it; the SPA CSP allows same-origin/inline styles.
import '../../../gen/client/react-ui/styles.css'

/**
 * CSS custom-property overrides that theme the generated ServiceExplorer to
 * match the app palette (primary indigo #1a56db, Roboto, rounded surfaces).
 * Only the CORE palette/typography tokens are overridden — the chip/badge
 * tokens are FOREGROUND accent colors in styles.css, so they are left at the
 * generated defaults. Names verified against gen/client/react-ui/styles.css.
 */
const explorerThemeVars: Record<string, string> = {
  '--genapi-ui-accent': '#1a56db',
  '--genapi-ui-accent-fg': '#ffffff',
  '--genapi-ui-bg': '#f5f6f8',
  '--genapi-ui-surface': '#ffffff',
  '--genapi-ui-border': '#e0e3e7',
  '--genapi-ui-text': '#1a2027',
  '--genapi-ui-text-muted': '#6b7280',
  '--genapi-ui-radius': '8px',
  '--genapi-ui-font': "'Roboto','Helvetica Neue',Arial,sans-serif",
  '--genapi-ui-font-size': '0.85rem',
}

// ---------------------------------------------------------------------------
// Themed docs container (styled-components + @devnw/theme tokens — replaces
// the previous MUI Container/Typography). See
// .superpowers/sdd/oidcpam-gate6-shared.md — OIDCPAM Gate-6 Phase 7.
// ---------------------------------------------------------------------------

const DocsContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: ${({ theme }) => ut(asUnified(theme)).space('lg')} 0;
`

const Heading = styled.h2`
  margin: 0 0 ${({ theme }) => ut(asUnified(theme)).space('md')};
  font-size: ${({ theme }) => asUnified(theme).font?.sizes?.xl ?? '1.5rem'};
  font-weight: 600;
  color: ${({ theme }) => asUnified(theme).text?.primary ?? '#0f172a'};
`

export const Docs = () => {
  return (
    <DocsContainer>
      <Heading>API Reference</Heading>

      <div style={explorerThemeVars as React.CSSProperties}>
        <ServiceExplorer baseUrl={window.location.origin} />
      </div>
    </DocsContainer>
  )
}
